import services from './_services'

export default {
  getMemberAudit () {
    return services.get(process.env.ROOT_API + '/members/audit/')
  }
}



// WEBPACK FOOTER //
// ./src/api/members.js